module.exports = __webpack_public_path__ + "141d4a85/img/settings-ico.a214628d.svg";